import React from 'react';

const About: React.FC = () => {
    return (
        <>
            <article className="aboutus">
                <h1>關於我們</h1>
                <p>EDI 軟體。是一家新成立的軟體開發公司，由對敏捷開發有著堅定信念的知名產業參與者組成。我們專注於遊戲管理系統 (GMS) 和 CRM 平台，並擁有從頭開始建立當今使用的一些最大系統的經驗。</p>
                <p>我們相信我們可以透過突破性的概念和想法來建立更好的解決方案，並且現在正在招募人員來實現這一願景。如果您具備以下特質：</p>
                <ul>
                    <li>透過擁抱 TDD 等軟體開發概念來編寫「美麗」的可維護程式碼有很強的親和力</li>
                    <li>對代碼品質有強烈的自豪感</li>
                    <li>喜歡嘗試尖端的開發方法和技術</li>
                </ul>
                <p>加入我們，看看您是否具備成為軟體大師的素質</p>
            </article>
            {/* <article className='aboutus'>
                <h1>About Us</h1>
                <p>EDI Soft. is a newly incorporated software development company by well-established Industry players who has strong belief on Agile development. We specialized in Games Management System (GMS) and CRM platforms, with experience in building from ground up some of the largest system in used today.</p>
                <p>We believe we can build better solutions with groundbreaking concepts and ideas and is now recruiting to build this vision. If you possess the following characteristics:</p>
                <ul>
                    <li>has strong affinity to writing ‘Beautiful’ maintainable code by embracing software development concepts such as TDD</li>
                    <li>has strong pride over code quality</li>
                    <li>enjoy experimenting with cutting edge development methods and technology</li>
                </ul>
                <p>Join US and see if you have what it takes to be a software guru</p>
            </article> */}
        </>
    );
};

export default About;